"use client";

import apiFetch from "@/lib/fetch";
import { useEffect, useState } from "react";
import { DEFAULT_DATA_LIMIT } from "@/@core/constants/pagination";
import InfiniteScroll from "@/components/InfiniteScroll";
import LocationCard from "../../../venue-listing/locationCard/LocationCard";
import SwatchIcon from "@heroicons/react/24/solid/SwatchIcon";
import { Link } from "@/components/CustomLink";
import { Skeleton } from "@/components/ui/skeleton";

export default function FeaturedServicesClient({
  initialData,
}: {
  initialData: any;
}) {
  const [isLoading, setIsLoading] = useState(true);
  const [featuredServices, setFeaturedServices] = useState<any[]>(initialData || []);
  const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    if (initialData.length < DEFAULT_DATA_LIMIT) {
      setHasMore(false);
    }
    setIsLoading(false);
  }, [initialData]);

  const fetchData = async (index = 0) => {
    setIsLoading(true);
    const res = await apiFetch({
      route: `service/featured?index=${index}`,
    });

    if (res.length < DEFAULT_DATA_LIMIT) {
      setHasMore(false);
    }
    setIsLoading(false);

    return res;
  };

  const next = (page: number) => {
    fetchData(page).then((data) => {
      setFeaturedServices([...featuredServices, ...data]);
    });
  };

  if (!Array.isArray(featuredServices) || !featuredServices) return <></>;

  if (!Array.isArray(featuredServices) || !featuredServices.length)
    return <></>;

  return (
    <>
      <InfiniteScroll
        hasMore={hasMore}
        next={next}
        loading={
          <>
            {Array.from(Array(16).keys()).map((index: number) => {
              return (
                <Skeleton
                  id="service-client-card-skeleton"
                  key={index}
                  className="lg:w-[284px] w-full h-[42px] font-bold px-4 py-3 bg-gray-secondary rounded-2xl justify-start items-center gap-2 inline-flex"
                />
              );
            })}
          </>
        }
        isLoading={isLoading}
        skeletonElementId="service-client-card-skeleton"
        dataLength={featuredServices?.length || 0}
      >
        {featuredServices.map((service: any) => (
          <Link
            key={service?.id}
            title={service?.descriptions?.[0]?.title}
            href={`/${service?.descriptions?.[0]?.slug}`}
            className="max-md:w-full"
          >
            <LocationCard
              icon={<SwatchIcon className="size-4" />}
              title={service?.descriptions?.[0]?.title}
            />
          </Link>
        ))}
      </InfiniteScroll>
    </>
  );
}
